import React from 'react';
import MenuRight from './MenuRight';
import MenuBottom from './MenuBottom.js';
import CenterButtons from './CenterButtons.js';
import Diamond from './images/Diamond.png';
import ActivityImg from './images/WorkForce.png';

function WorkForce({ changeActiveComponent }) {
  const changeComponent = (id) => {
    if (id === 'assign') {
      changeActiveComponent('workforceassign');
    } else if (id === 'assigned') {
      changeActiveComponent('workforceunassign');
    }
  };

  return (
    <section id="workforce">
      <div className="platform-container">
      <div className="platform-activity-container">
          <div className="activity-container">
            <div className="activity-image-container"><img src={ActivityImg}/></div>
            <div className="activity-activity-container"><h2>WORKFORCE</h2><p>Assign your ANT into workforce to earn ANT Coins based on your ANT level reward APY%</p></div>
            <div className="activity-advantages-container"><h2>ADVANTAGE</h2><p>Worker ANTs get 5% base APY on top of ANT Level APY</p></div>
            <CenterButtons changeComponent={changeComponent} /></div>
          </div>
      </div>
    </section>
  );
}

export default WorkForce;